import { InputField } from "components/input-field";
import { UsuarioBancoErrors } from ".";
import { UsuarioBanco } from "../page";
import { Box, Text } from "@chakra-ui/react";
import { DropdownField } from "components/dropdown-field";
import { higienizadorConveniosOptions } from "./utils";

export function MargemConveniosFields({
  modalData,
  onChangeUsuarioBancoDialog,
  errors,
}: {
  modalData: UsuarioBanco;
  onChangeUsuarioBancoDialog: (
    field: keyof UsuarioBancoErrors,
    value: string
  ) => void;
  errors: UsuarioBancoErrors;
}) {
  return (
    <>
      <Box mb="15px">
        <InputField
          title="Usuário"
          value={modalData.username}
          onChange={(e) =>
            onChangeUsuarioBancoDialog("username", e.target.value)
          }
          errorMessage={errors.username ? "Informe um usuário" : undefined}
        />
      </Box>
      <Box mb="15px">
        <InputField
          title="Senha"
          value={modalData.password}
          onChange={(e) =>
            onChangeUsuarioBancoDialog("password", e.target.value)
          }
          errorMessage={errors.password ? "Informe uma senha" : undefined}
        />
      </Box>

      <Box mb="15px">
        <Text mb="8px">Convenios</Text>
        <DropdownField
          value={modalData.botIdCronowise}
          onChange={(value) =>
            onChangeUsuarioBancoDialog("botIdCronowise", value)
          }
          options={higienizadorConveniosOptions}
          dropdownProps={{ w: "100%" }}
          errorMessage={
            errors.botIdCronowise ? "Informe um convênio" : undefined
          }
        />
      </Box>
    </>
  );
}
